module.exports = __webpack_public_path__ + "media/images/common/sns/tiktok-e066920464fd81ad2d5ef1bd97d2c4cc.svg";